export default __webpack_public_path__ + "static/media/mockupChamados1.3c0d7d96.png";